import { createIndexLookupMap } from './utils';

// TODO: These should eventually be retired in favor of using baseTheme.palette values
export const carrotColors = {
    black: '#000000',
    black80: '#000000CC',
    black60: '#00000099',
    black40: '#00000066',
    black30: '#0000004d',
    black10: '#0000001A',
    gray: '#CCCCCC',
    lightGrey: '#F5F5F5',
    white: '#FFFFFF',
    darkCarrotOrange: '#C97500',
    carrotOrange: '#e48400',
    carrotOrange35: 'rgba(228, 132, 0, 0.35)',
    lightCarrotOrange: '#FAE6CC',
    veryLightCarrotOrange: '#FCF3E5',
    coral: '#EBA378',
    lightRed: '#F4DAD7',
    errorRed: '#D26556',
    warmGray: '#EEDDCD',
    pampas: '#F4F2EF',
    lightPampas: '#FAF9F7',
    darkGreen: '#347559',
    mint: '#C2DBCC',
    mintAlternate: '#DDEBE2',
    darkBlue: '#15415B',
    midBlue: '#417091',
    patternsBlue: '#D3DFE3',
    lightBlue: '#E0E8EA',
    // Legacy,
    darkOldRose: '#9a4856',
} as const;

export const borderWidth = {
    none: 0,
    sm: '0.0625rem',
    md: '0.125rem',
    lg: '0.25rem',
} as const;

export const spacingLookupTable = {
    none: 0,
    xxxs: '0.125rem',
    xxs: '0.25rem',
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '2.5rem',
    xxxl: '3rem',
} as const;

/**
 * The calculated value of each value is determined by the index of the values of spacingTable above.
 * Example: spacing.xs is 3, so Object.values(spacingLookupTable)[3] == 8
 *
 * We do this to better align ourselves with MUI's theme https://mui.com/system/spacing/
 */
export const spacing = createIndexLookupMap<keyof typeof spacingLookupTable>(spacingLookupTable);

export * from './radius';
